import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/NewAuth.css";

const SessionExpiredModal = ({ onClose }) => {
    const { t } = useTranslation('auth');

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{t('sessionExpired.title')}</h2>
                <p>{t('sessionExpired.message')}</p>
                <button onClick={onClose} className="close-btn">{t('sessionExpired.ok')}</button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;
